import { layout } from '../../App.routing'

export const climateChangeSegment = layout.component({
    type: 'lima',
    feature: 'climate-change-home',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        intermediateColumns: 2,
        finalColumns: 4,
        hideByline: false,
        hasBackground: true,

        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
            ],
        ],
        cardOrientation: { type: 'Landscape-Portrait' },
        sectionHeader: {
            heading: 'Climate Change',
            headingUrl: '/news/climate-change',
            section: 'news',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'climate-change',
            offset: 0,
            pageSize: 6,
        },
    },
})
